import type { FaireProductEntity } from "../../entity_types/product";

export const p_6za2wg6kq4: FaireProductEntity = {
  token: "p_6za2wg6kq4",
  type: "product",
  name: "Gold Shell Pendant Necklace with Pearl",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/00e8940e73a84f89a343f0fc4f251ee4103d0aaebdca4d9f99b6046baa2aeae4.jpeg",
  priceDollars: 10.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/38ff3805f7573b4c24d425482a1d43d688185eeba1639c606cbfb488e8296d1b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
